import React, { FC } from 'react';
import { NameLinkObject } from '@components/EntityDrawers/constants/empty-objects';
import { InitiativeKeys } from '@components/EntityDrawers/drawers/Initiative/keys';
import ControlledInputGroups, {
  InputsBlockProps,
} from '@components/Inputs/controllers/ControlledInputGroups/ControlledInputGroups';
import ControlledLinkInput from '@components/Inputs/controllers/ControlledLinkInput';
import ControlledTextField from '@components/Inputs/controllers/ControlledTextField';
import { useProject } from '@context/Project/ProjectProvider';
import { getInputGroupsProps } from '@utils/helpers';

const DocumentInputs: FC<InputsBlockProps> = ({ createName, viewOnly }) => (
  <>
    <ControlledTextField
      name={createName('name')}
      label="Document name"
      placeholder="Document name"
      disabled={viewOnly}
      multiline
    />

    <ControlledLinkInput
      name={createName('link')}
      label="Document link"
      placeholder="Document link"
      disabled={viewOnly}
      multiline
    />
  </>
);

const DocumentsGroup: FC = () => {
  const { viewOnly } = useProject();

  return (
    <ControlledInputGroups
      name={InitiativeKeys.Document}
      viewOnly={viewOnly}
      groupObject={NameLinkObject}
      {...getInputGroupsProps('supporting document')}
    >
      {DocumentInputs}
    </ControlledInputGroups>
  );
};

export default DocumentsGroup;
